<div id="main-content" *ngIf="disputePojo; else loading" class="wrapper has-padding"
    (focusout)="onFocusOutMainContent($event)">
    <form [formGroup]="disputeGroup" (ngSubmit)="onSubmit()">

        <div class = "maxwidth-750">
            <h1 class="bofa--heading is-4">Dispute Questionnaire</h1>

            <p class="bottom-space">Please complete the following information and submit your request to begin
                the dispute process.</p>

            <!-- Generate questions based on questionId recieved from ws -->
            <div *ngFor="let disputeQuestionAnswer of disputePojo.disputeQuestionAnswer;">
                <div *ngIf="disputeQuestionAnswer.questionId == 3">
                    <mat-form-field class="resize-dispute">
                        <mat-label id="dispute-question-label"><abbr title="required">* </abbr>{{disputeQuestionAnswer.questionName}}</mat-label>
                        <textarea class="textarea-resize" matInput maxlength="2000" required
                            formControlName="{{disputeQuestionAnswer.questionId}}" cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="50" aria-labelledby="dispute-question-label"></textarea>
                        <mat-hint align="end">
                            {{disputeGroup.get('3').value.length}} / 2000
                        </mat-hint>
                        <mat-error>
                            Invalid input. Please enter correct data.</mat-error>
                    </mat-form-field>
                </div>

                <div class="bottom-space" *ngIf="disputeQuestionAnswer.questionId != 3">
                    <label class="minor-list-space" [attr.for]="'question-' + disputeQuestionAnswer.questionId"><abbr title="required">*
                        </abbr>{{disputeQuestionAnswer.questionName}}
                    </label>
                    <mat-radio-group class="minor-radio-padding" required
                        formControlName="{{disputeQuestionAnswer.questionId}}" [attr.id]="'question-' + disputeQuestionAnswer.questionId">
                        <mat-radio-button class="minor-list-space radio-padding" matInput value="1" name="yes">Yes
                        </mat-radio-button>
                        <mat-radio-button class="minor-radio-padding" matInput value="2" name="no">No
                        </mat-radio-button>
                        <mat-error
                            *ngIf="hasBeenSubmitted && disputeGroup.controls[disputeQuestionAnswer.questionId].hasError('required')">
                            Please answer '{{disputeQuestionAnswer.questionName}}'
                        </mat-error>
                    </mat-radio-group>
                </div>
                <br />
            </div>

            <div *ngIf="showAttachmentSection">
                <div>
                    <mat-card appearance="outlined" class="af-mat-card mat-elevation-z">

                        <mat-card-content>
                            <p> <img alt="information" src="assets/bofa_icon_info.svg" class="img-size" role="img"> Please attach
                                the documentation to this request by clicking the "Attach file" button below. If you
                                have more than one document to attach, please click the "Attach file" button again. </p>
                        </mat-card-content>
                    </mat-card>
                </div>

                <div class="is-stacked">
                    <button type="button" class="bofa--button secondary outlined height-300-padding"
                        color="primary"
                        [disabled]="formSubmitted" (click)="openFileDialog(true)" aria-label="attach optional file">
                        <span> <img role="img" class = "width-height-marginbottom-paddingleft" alt=""
                                src="assets/icon_document.svg"></span> <span class = "padding-10"> Attach file</span>
                    </button>
                </div>

                <div class="table-container bottom-space">
                    <table mat-table aria-labelledby="tableDesc" [dataSource]="dataSource">
                        <ng-container matColumnDef="attachmtFileName">
                            <td mat-cell *matCellDef="let element">
                                <span><a href="/bsiAF/api/downloadAsiAttachment?attachmentId={{element.attachmentId}}"
                                        class="af-anchor" aria-label="download {{element.attachmtFileName}}"> {{element.attachmtFileName }}
                                    </a></span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="remove">

                            <td class="text-center" mat-cell *matCellDef="let element">
                                <div class = "marginleft">
                                    <img tabindex="0" (keyup.enter)="removeAttachment(element.attachmentId)"
                                        (click)="removeAttachment(element.attachmentId)"
                                        src="assets/bofa_icon_close2_186rgb.svg"
                                        class = "width-height-cursor" alt="remove attachment" role="img" />
                                </div>
                            </td>
                        </ng-container>


                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
                <mat-error *ngIf="noAttachment">Please attach at least one file in response to
                    'Can you provide additional documentation to help clarify the discrepancy identified?'</mat-error>
            </div>
        </div>
        <!-- Save / Save and Finish Later / Submit -->
        <div class="is-taller" class="paddingtop-50">
            <div class="level">
                <div class="level-region level-nav">
                    <button type="button"
                        class="bofa--button secondary dark-blue save-ie save-margin ui-font save-height"
                        (click)="onClickSave()">Save</button>

                    <button type="button" class="bofa--button secondary outlined ui-font"
                        (click)="onClickSaveAndFinishLater()">Save
                        and finish later</button>
                </div>
                <div class="level-item level-nav">
                    <button type="submit" class="bofa--button primary large ui-font">Submit</button>
                </div>
            </div>
        </div>
    </form>
</div>
<ng-template #loading>
    Loading Applicant User...
</ng-template>
